module.exports = __webpack_public_path__ + "img/clothing84.89886d78.jpg";